import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background">
      <SEO title="Условия за ползване" description="Условия за ползване на сайта на GreenCastle." url="/terms" />
      <Header />
      <section className="pt-32 pb-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading text-4xl font-bold text-foreground mb-8">Условия за ползване</h1>

          <div className="prose prose-green max-w-none text-foreground/80 space-y-6">
            <p>Последна актуализация: {new Date().getFullYear()} г.</p>

            <h2 className="font-heading text-2xl font-semibold text-foreground mt-8 mb-3">1. Приемане на условията</h2>
            <p>Използвайки уебсайта greencastle.bg, вие се съгласявате с настоящите условия за ползване. Ако не сте съгласни с тях, моля не използвайте сайта.</p>

            <h2 className="font-heading text-2xl font-semibold text-foreground mt-8 mb-3">2. Интелектуална собственост</h2>
            <p>Всички материали на сайта — текстове, изображения, лога и дизайн — са собственост на GreenCastle и са защитени от авторско право. Забранено е копирането или разпространението им без изрично писмено разрешение.</p>

            <h2 className="font-heading text-2xl font-semibold text-foreground mt-8 mb-3">3. Съдържание на сайта</h2>
            <p>GreenCastle полага усилия информацията на сайта да е актуална и точна, но не носи отговорност за евентуални неточности. Цените и наличността на имотите могат да се променят без предупреждение.</p>

            <h2 className="font-heading text-2xl font-semibold text-foreground mt-8 mb-3">4. Ограничения на отговорността</h2>
            <p>GreenCastle не носи отговорност за вреди, произтичащи от използването или невъзможността за използване на сайта или предоставената информация.</p>

            <h2 className="font-heading text-2xl font-semibold text-foreground mt-8 mb-3">5. Промени в условията</h2>
            <p>GreenCastle си запазва правото да променя настоящите условия по всяко време. Промените влизат в сила от момента на публикуването им на сайта.</p>

            <h2 className="font-heading text-2xl font-semibold text-foreground mt-8 mb-3">6. Приложимо право</h2>
            <p>Настоящите условия се уреждат от законите на Република България. При спорове е приложима юрисдикцията на компетентните български съдилища.</p>

            <h2 className="font-heading text-2xl font-semibold text-foreground mt-8 mb-3">7. Контакт</h2>
            <p>При въпроси относно условията за ползване, свържете се с нас:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Имейл: office@greencastle.bg</li>
              <li>Телефон: +359 890 300 600</li>
            </ul>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
